import { createAction } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import type { CropActionPayload, UploadOptions } from '@sda/interfaces/reducer/uploads.reducer';

export const startUpload = createAction<{
  files: File[];
  name: string;
  options?: UploadOptions;
}>(`${Reducers.UPLOADS}/startUpload`);

export const startCrop = createAction<CropActionPayload>(`${Reducers.UPLOADS}/startCrop`);
